module.exports = __webpack_public_path__ + "static/media/51.3d96ff2f.jpg";